import { render, staticRenderFns } from "./HowToSpotCancerEarly.vue?vue&type=template&id=3e3f8d35&"
import script from "./HowToSpotCancerEarly.vue?vue&type=script&lang=js&"
export * from "./HowToSpotCancerEarly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports